import { PRODUCTS } from 'domain/enums'
import { PRODUCT_DATE } from 'domain/enums/dateFilter'
import {
  AUTO_STEPS_LIST,
  HOME_STEPS_BCREDI_LIST,
  HOME_FIN_STEPS,
} from 'domain/enums/proposalSteps'
import {
  SITUATION_PROPOSALS_FILTER,
  SITUATION_PROPOSALS_HOME_FIN_FILTER,
} from 'domain/enums/situationProposal'
import React, { useRef } from 'react'
import { InputSearch } from 'shared/ui'
import { useFilters } from '../../../application/useFilters.hook'
import { SpacingSection } from '../Home.styles'
import { Collaterals, ListFilters } from './styles'
import { Tab } from 'homepage/presentation/components/Tab'

const CollateralItems = ({
  inputRef,
  queryPath,
  loading,
  handleSearch,
  productType,
  collateralItems,
  date,
  handleDateFilter,
  stepQueryParam,
  handleCollateralStep,
  situation,
  handleStatusFilter,
}) => {
  const handleProductSteps = () => {
    switch (productType) {
      case PRODUCTS.AUTO:
        return collateralItems(AUTO_STEPS_LIST)
      case PRODUCTS.HOME:
        return collateralItems(HOME_STEPS_BCREDI_LIST)
      case PRODUCTS.HOME_FIN:
        return collateralItems(HOME_FIN_STEPS)
      default:
        return collateralItems(HOME_STEPS_BCREDI_LIST)
    }
  }

  return (
    <>
      <InputSearch
        style={{ gridArea: 'search' }}
        data-testid="filter_search"
        ref={inputRef}
        value={queryPath.get('query') || ''}
        id="search"
        label="Buscar por nome ou CPF"
        loading={loading}
        disabled={loading}
        onSearch={handleSearch}
      />
      <Collaterals
        style={{ gridArea: 'date' }}
        data-testid="filter_date"
        text="Data"
        value={date}
        options={collateralItems(PRODUCT_DATE)}
        disabled={loading}
        onChangeOption={handleDateFilter}
      />
      <Collaterals
        style={{ gridArea: 'step' }}
        data-testid="filter_step"
        text="Etapa"
        value={stepQueryParam}
        options={handleProductSteps()}
        disabled={productType === ''}
        onChangeOption={handleCollateralStep}
      />
      <Collaterals
        style={{ gridArea: 'status' }}
        data-testid="filter_status"
        text="Status"
        value={situation}
        options={collateralItems(
          productType !== PRODUCTS.HOME_FIN
            ? SITUATION_PROPOSALS_FILTER
            : SITUATION_PROPOSALS_HOME_FIN_FILTER,
        )}
        disabled={productType === ''}
        onChangeOption={handleStatusFilter}
      />
    </>
  )
}

const Filters = () => {
  const inputRef = useRef()

  const {
    queryPath,
    loading,
    handleSearch,
    productType,
    collateralItems,
    handleCollateralFilter,
    date,
    handleDateFilter,
    stepQueryParam,
    handleCollateralStep,
    situation,
    handleStatusFilter,
  } = useFilters()

  return (
    <>
      <Tab
        productType={productType}
        handleCollateralFilter={handleCollateralFilter}
      />
      <SpacingSection>
        <ListFilters>
          <CollateralItems
            inputRef={inputRef}
            queryPath={queryPath}
            loading={loading}
            handleSearch={handleSearch}
            productType={productType}
            collateralItems={collateralItems}
            handleCollateralFilter={handleCollateralFilter}
            date={date}
            handleDateFilter={handleDateFilter}
            stepQueryParam={stepQueryParam}
            handleCollateralStep={handleCollateralStep}
            situation={situation}
            handleStatusFilter={handleStatusFilter}
          />
        </ListFilters>
      </SpacingSection>
    </>
  )
}

export { Filters }
